module.exports = {
      id: "presentation_material-usage",
      viewBox: "0 0 353.6 325.47",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#presentation_material-usage",
      toString: function () {
        return this.url;
      }
    }